import { Building2Icon, CrownIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { SearchResult, SearchResultHighlights } from '@/shared/registry/types';

/**
 * A department on the search page (identity `department` document; the content of the page's link row): name, head
 * and parent from the document's meta.
 */
export function DepartmentSearchResult({
  result,
  highlights,
}: {
  result: SearchResult;
  highlights?: SearchResultHighlights;
}) {
  const { t } = useTranslation('company');
  const meta = result.meta ?? {};
  return (
    <>
      <span className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-brand-soft text-brand-text">
        <Building2Icon className="size-5" aria-hidden />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-[0.9375rem] font-medium text-foreground">
          {highlights?.title ?? result.title}
        </span>
        <span className="flex min-w-0 items-center gap-1.5 text-sm text-muted-foreground">
          {meta.headName && (
            <>
              <CrownIcon className="size-3.5 shrink-0 text-warning-text" aria-hidden />
              <span className="truncate">{meta.headName}</span>
            </>
          )}
          {meta.headName && meta.parentName && <span aria-hidden>·</span>}
          {meta.parentName && <span className="truncate">{meta.parentName}</span>}
          {!meta.headName && !meta.parentName && t('search.department')}
        </span>
      </span>
    </>
  );
}
